import React, { useEffect, useRef } from "react";
import WhatsappMessage from "./WhatsappMessage";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import MessengerMessage from "./MessengerMessage";
import InstagramMessage from "./InstagramMessage";

function LiveChatPreview({ messageList, contact, setCanSendMsg, isOpenWebLiveChat = false }) {
  const lastItemRef = useRef(null);
  const globalReducer = useSelector((state) => state.globalReducer);
  const wabaTimezone =
    globalReducer.waba?.timezone ??
    Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    setTimeout(() => focusLastItem(), 50);
  }, [messageList?.length]);

  const groupedData = messageList?.reduce((acc, item) => {
    const date = moment(item.createdAt).format("YYYY-MM-DD");
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(item);
    return acc;
  }, {});

  useEffect(() => {
    const date = moment().utc().subtract(24, "hours");
    const smsList = messageList?.filter((item) => moment.utc(item?.createdAt).isAfter(date));
    if (smsList?.length > 0) {
      if (smsList?.some((item) => ((Array.isArray(item.messageText) && item?.messageText[0]?.from) || item?.isReceived === true
        || (item.type?.toLowerCase() === "template" && !["failed", "invalid"].includes(item.messageStatus?.toLowerCase()))))) {
        {
          setCanSendMsg(true);
        }
      } else setCanSendMsg(false);
    } else setCanSendMsg(false);
    if (contact?.contact?.createdForm === "WEBLIVECHAT") {
      setCanSendMsg(true);
    }
  }, [groupedData]);

  const formatDate = (date) => {
    const givenDate = moment.utc(date).tz(wabaTimezone).startOf("day");
    const today = moment().utc().tz(wabaTimezone).startOf("day");
    const tomorrow = moment()
      .utc()
      .tz(wabaTimezone)
      .add(-1, "day")
      .startOf("day");

    if (givenDate.isSame(today, "day")) {
      return "Today";
    } else if (givenDate.isSame(tomorrow, "day")) {
      return "Yesterday";
    } else {
      return givenDate.format("dddd, MMMM D, YYYY");
    }
  };
  const focusLastItem = () => {
    lastItemRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  };
  const getWhatsappMessage = (selectedMessage) => {
    if (!selectedMessage) return <></>;
    if (selectedMessage?.source?.includes("MESSENGER")) {
      if (selectedMessage?.messageText?.reply_to) {
        const msg = messageList?.find(
          (f) => f.referenceId === selectedMessage?.messageText?.reply_to?.mid
        );
        return (
          <div className="bg-[#f7f8fc] text-black rounded-xl pt-[6px] pr-[7px] pb-[8px] pl-[9px]">
            <div className="bg-[#eceef6] rounded-[8px] border-l-[3px] border-theme flex text-gray-500">
              <MessengerMessage message={msg} isReply={true} />
            </div>
            <MessengerMessage message={selectedMessage} />
          </div>
        );
      }
      return <MessengerMessage message={selectedMessage} />;
    }
    if (selectedMessage?.source?.includes("INSTAGRAM")) {
      if (selectedMessage?.messageText?.reply_to) {
        const msg = messageList?.find(
          (f) => f.referenceId === selectedMessage?.messageText?.reply_to?.mid
        );
        return (
          <div className="bg-[#f7f8fc] text-black rounded-xl pt-[6px] pr-[7px] pb-[8px] pl-[9px]">
            <div className="bg-[#eceef6] rounded-[8px] border-l-[3px] border-theme flex text-gray-500">
              <InstagramMessage message={msg} isReply={true} />
            </div>
            <InstagramMessage message={selectedMessage} />
          </div>
        );
      }
      return <InstagramMessage message={selectedMessage} />;
    }
    const msgText = selectedMessage?.messageText && Array.isArray(selectedMessage?.messageText)
      ? selectedMessage.messageText[0]
      : selectedMessage.messageText ?? {};
    if (msgText?.context?.from) {
      const msg = messageList?.find(
        (f) => f.referenceId === msgText?.context?.id
      );
      return (
        <div className="bg-[#f7f8fc] text-black rounded-xl pt-[6px] pr-[7px] pb-[8px] pl-[9px]">
          <div className="bg-[#eceef6] rounded-[8px] border-l-[3px] border-theme flex text-gray-500">
            <WhatsappMessage message={msg} isReply={true} selectedContact={contact} isOpenWebLiveChat={isOpenWebLiveChat} />
          </div>
          <WhatsappMessage message={selectedMessage} isReplied={true} selectedContact={contact} isOpenWebLiveChat={isOpenWebLiveChat} />
        </div>
      );
    }
    return <WhatsappMessage message={selectedMessage} selectedContact={contact} isOpenWebLiveChat={isOpenWebLiveChat} />;
  };
  const getJustifyContent = (item) => {
    if (isOpenWebLiveChat == true) {
      if ((item.isReceived === false)) {
        item.justifyEnd = false;
        return "flex-start";
      } else {
        item.justifyEnd = true;
        return "justify-end";
      }
    } else {
      if ((item?.isReceived === true) || (Array.isArray(item?.messageText) && item?.messageText[0]?.from)) {
        item.justifyEnd = false;
        return "flex-start";
      } else {
        item.justifyEnd = true;
        return "justify-end";
      }
    }
  }
  return (
    <div className="flex flex-col w-auto">
      {Object.keys(groupedData)?.map((date, d) => (
        <div key={date}>
          <div className="relative py-3">
            <div className="absolute inset-0 top-[30%] flex items-center mb-[12px]">
              <div className="w-full border-b border-gray-100" />
            </div>
            <div className="relative flex justify-center">
              <div className="border-[1px] h-7 bg-white border-gray-300 content-center rounded-full">
                <div className="flex content-center px-3">
                  <div className="text-xs font-medium text-gray-700 bg-white">
                    {formatDate(date)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="relative">
              {groupedData[date]?.map((item, index) => (
                <div
                  key={item.id || index}
                  ref={
                    Object.keys(groupedData).length - 1 === d &&
                      index === groupedData[date]?.length - 1
                      ? lastItemRef
                      : null
                  }
                  className={`relative group flex ${getJustifyContent(item)} w-full h-auto py-1 pb-1.5`}
                >
                  <div className="max-w-[85%] sm:max-w-[60%]">
                    <div className="flex gap-2 flex-start">
                    </div>
                    <div className="flex items-start flex-col">
                      {getWhatsappMessage(item)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default LiveChatPreview;
